/**
 * The palette's key map (PLAN §2.4), as a pure function: a keydown inside the
 * palette → an intent. The component decides what an intent does.
 *
 *   ↑ / ↓ (and Ctrl+P / Ctrl+N on macOS)   prev / next
 *   PageUp / PageDown, Home / End          jump
 *   Enter / ⌘↵ Ctrl+↵                      run / run in a new tab
 *   → (caret at the end) or Tab            actions, or enter the scope
 *   ←                                      back out of the actions
 *   Esc                                    back / remove the chip / close
 *   Backspace on an empty query            undo the chip
 *   ⌘C / Ctrl+C with no text selected      copy the row's link
 *   Shift+Tab                              stays (focus never leaves the palette)
 */
export function intentFor(e, { caretAtEnd = true, hasTextSelection = false, subMenuOpen = false, isMac = false } = {}) {
  const mod = isMac ? e.metaKey : e.ctrlKey;
  const k = e.key;
  if (e.isComposing) return null;
  if (k === 'ArrowDown' || (isMac && e.ctrlKey && !e.metaKey && (k === 'n' || k === 'N'))) return 'next';
  if (k === 'ArrowUp' || (isMac && e.ctrlKey && !e.metaKey && (k === 'p' || k === 'P'))) return 'prev';
  if (k === 'PageDown') return 'pageDown';
  if (k === 'PageUp') return 'pageUp';
  if (k === 'Home' && (subMenuOpen || mod)) return 'home';
  if (k === 'End' && (subMenuOpen || mod)) return 'end';
  if (k === 'Enter') return mod ? 'runNewTab' : 'run';
  if (k === 'Tab' && !e.shiftKey && !mod && !e.altKey) return 'actions';
  if (k === 'Tab' && e.shiftKey) return 'stay'; // focus never leaves the palette
  if (k === 'ArrowRight' && !mod && !e.shiftKey && (caretAtEnd || subMenuOpen)) return 'actions';
  if (k === 'ArrowLeft' && subMenuOpen) return 'back';
  if (k === 'Escape') return 'escape';
  if (k === 'Backspace' && !mod) return 'backspace';
  if ((k === 'c' || k === 'C') && mod && !e.shiftKey && !hasTextSelection) return 'copyLink';
  if ((k === 'c' || k === 'C') && mod && e.shiftKey) return 'copyKey';
  return null;
}
